import React, { useState, useEffect } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import db from "../../../api/mongodb";
import { Container, Row, Col, Image, Card, Button } from "react-bootstrap";
import { defaultOptions1 } from "../../../config/loading-config.js";
import Lottie from "react-lottie";
import "./ClientProfile.scss";
import ProfileTabs from "../../ProfileTabs";
import dummyProfilePicture from "../../../images/dummy-profile-picture.svg";
import { formatPhoneNumber } from "../directory/logic/utils";
import { useQuery } from "@tanstack/react-query";
import SafeAPProfileListSection from "../safeAPs/ui/SafeAPProfileListSection.js";

const SafeAPProfile = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [courses, setCourses] = useState([]);
  const [client, setClient] = useState({});
  const [actprojects, setActProjects] = useState([]);
  const [comprojects, setComProjects] = useState([]);

  const [registrationDate, setRegistrationDate] = useState("");
  const { id } = useParams();

  const clientInformationQuery = useQuery({
    queryKey: ["client", id],
    queryFn: async () => {
      const response = await db.get(`/api/clients/getClientInformation/${id}`);
      return response.data;
    },
  });

  useEffect(() => {
    if (clientInformationQuery.status === "success") {
      setClient(clientInformationQuery.data.client);
      setRegistrationDate(
        clientInformationQuery.data.client.createdAt.split("T")[0]
      );

      setActProjects(
        clientInformationQuery.data.projects.filter(
          (project) => project.status === "active"
        )
      );
      setComProjects(
        clientInformationQuery.data.projects.filter(
          (project) => project.status === "completed"
        )
      );
    }
  }, [clientInformationQuery.status, clientInformationQuery.isFetching]);

  if (
    clientInformationQuery.isPending ||
    JSON.stringify(client) === JSON.stringify({})
  ) {
    return <Lottie options={defaultOptions1} height={200} width={200} />;
  }

  return (
    <div>
      <Card>
        <Card.Body>
          <div>
            <img
              src={
                client.formData.clientProfileImg &&
                client.formData.clientProfileImg.length
                  ? client.formData.clientProfileImg[0].content
                  : dummyProfilePicture
              }
              style={{ borderRadius: "100px", width: "150px", height: "150px" }}
            ></img>
          </div>
          <div>
            <div>
              <h1>
                {" "}
                {client.formData.clientFirstName}{" "}
                {client.formData.clientLastName}
              </h1>
            </div>
            <div>Since {registrationDate}</div>
            <div>
              <div>
                {client.formData && client.formData.clientAddress}{" "}
                {client.formData && client.formData.clientZipPostalCode},
                {client.formData && client.formData.clientCity},{" "}
                {client.formData && client.formData.clientStateProvince},
                {client.formData && client.formData.clientCountry}
              </div>
              <div>{client.formData && client.formData.clientEmail}</div>
              <div>
                {client.formData &&
                  formatPhoneNumber(client.formData.clientPhone)}
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
      <div>&nbsp;</div>
      {clientInformationQuery.data.allowEdit && (
        <Link to={`/clients/edit/${id}`}>
          <Button className="edit-profile-btn"> Edit Profile </Button>
        </Link>
      )}

      <Card className="safe-ap-profile-subsection">
        <Card.Body>
          <div className="safe-ap-profile-list-wrapper">
            <h4>Client Projects</h4>
            <div style={{ margin: "20px" }}>
              <div className="safe-ap-profile-list-content">
                <ProfileTabs>
                  <div label="Active">
                    <SafeAPProfileListSection
                      listItems={actprojects}
                      isProject={true}
                    />
                  </div>
                  <div label="Completed">
                    <SafeAPProfileListSection
                      listItems={comprojects}
                      isProject={true}
                    />
                  </div>
                </ProfileTabs>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default SafeAPProfile;
